import obdDataMonitorMeasureListItem from "../../../../vue/obd/individual/dataMonitor/ObdDataMonitorMeasureListItem";
import obdDataConversion from "./didDataConversion";
import dmUtil from "../../../dataMonitor/dataMonitorUtil";
import dataMonitorMeasureList from "../../../dataMonitor/DataMonitorMeasureList";

import { shallowRef } from "vue";
import { getTranslateValue } from "./dataMonitorUtil";

const COMPONENT_NAME = "ObdDataMonitorMeasureList";

export default {
  name: COMPONENT_NAME,

  extends: dataMonitorMeasureList,

  data() {
    return {
      // 表のセルに使用するコンポーネントをオーバーライド
      itemComponent: shallowRef(obdDataMonitorMeasureListItem),
    };
  },

  methods: {
    /**
     * 表示用の計測データ作成。
     * 継承元から処理をオーバーライド。
     */
    getMeasurementItems(executionList) {
      const items = [];
      let index = 0;

      for (const func of this.selectedFunctionList) {
        // 計測データ
        const conversionInfo = this.conversionList[func.data_monitor_id];
        const targetExecution = executionList[func.data_monitor_id];
        let item = {};
        if (targetExecution && dmUtil.VALUE_TRANSLATE_TYPE.includes(conversionInfo.data_type)) {
          const translated = getTranslateValue(this, func.data_monitor_id, targetExecution['convertedData'], conversionInfo);
          item = { ...targetExecution, convertedData: translated };
        } else if (targetExecution && dmUtil.VALUE_CONVERT_DECIMAL_TYPE.includes(conversionInfo.data_type)) {
          const displayValue = obdDataConversion.convertDataToDisplayValue(targetExecution['convertedData'], conversionInfo);
          item = { ...targetExecution, convertedData: displayValue };
        } else {
          item = targetExecution;
        }

        // データセット
        items.push(this.itemsFormatter(func.data_monitor_id, item, func.menu_title, index, conversionInfo));

        index++;
      }
      return items;
    },

    /** 
     * 取得データの整形処理。
     * 継承元から処理をオーバーライド。
     * @param {string} data_monitor_id DID
     * @param {object} item 計測データ
     * @param {string} name 項目名
     * @param {Number} index 行番号
     * @param {object} conversionInfo 変換情報(OBDでは使用しない)
     * @param {string} region リージョン情報(OBDでは使用しない)
     * @param {string} systemName システム名(OBDでは使用しない)
     * @returns {object} 整形データ
     */
    // 継承元で定義しているがOBDでは不要なため、次行のみESLintを抑制
    // eslint-disable-next-line no-unused-vars
    itemsFormatter(data_monitor_id, item, name, index, conversionInfo, region, systemName) {
      const format_data = {
        data_monitor_id: data_monitor_id,
        splitCheck: this.selectedGraphCheckList[index].checkValue[0],
        unionCheck: this.selectedGraphCheckList[index].checkValue[1],
        line: index,
        name: name,
        value: null,
        unit: null,
        max: null,
        min: null,
        avg: null,
        index: index
      };

      // 最大/最小/平均
      const funcVal = this.funcValues[data_monitor_id];
      if (funcVal) {
        const cache = new dmUtil.Cache();
        const cachedValue = cache.get(dmUtil.CACHE_CATEGORY.UNIT, funcVal.unit);
        // 0や空文字の場合はキャッシュを利用するため、nullやundefinedの時のみ翻訳情報を取得する
        if (cachedValue !== undefined && cachedValue !== null) {
          format_data.unit = cachedValue;
        } else {
          format_data.unit = this.$t(funcVal.unit);
          cache.set(dmUtil.CACHE_CATEGORY.UNIT, funcVal.unit, format_data.unit);
        }

        format_data.max = funcVal.maxDisp;
        format_data.min = funcVal.minDisp;
        format_data.avg = funcVal.avgDisp;
      }

      // 計測データあり
      if (item) {
        format_data.value = item.convertedData;
      }
      // 計測データ無し
      else {
        const filteredData = this.preItems.find(item => item.data_monitor_id === data_monitor_id);
        if (filteredData) {
          // 直前の値あり
          format_data.value = filteredData.value;
        }
      }

      return format_data;
    },
  }
};
